// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assistant-forms .multiselect,.assistant-forms .multiselect .multiselect__content-wrapper,.assistant-forms .multiselect .multiselect__tags,.assistant-forms input.sb2-bordered,.form-block .multiselect,.form-block .multiselect .multiselect__content-wrapper,.form-block .multiselect .multiselect__tags,.form-block input.sb2-bordered{border-radius:10px!important}", ""]);
// Exports
module.exports = exports;
